module.exports = __webpack_public_path__ + "img/119.4.bd7afce3.png";